import { getResolvedAppLang } from '../utils/cookie.js';

export default function initChangeLanguage() {
	const changeLanguage = document.getElementById('language');
	if (!changeLanguage) return;

	const currentLang = getResolvedAppLang();

	changeLanguage.addEventListener('change', async () => {
		const language = changeLanguage.value;
		const form = new FormData();
		form.append('action', 'change_user_language');
		form.append('nonce', wpcore.nonce);
		form.append('language', language);

		try {
			const response = await fetch(wpcore.ajaxUrl, {
				method: 'POST',
				body: form,
			});

			const data = await response.json();
			const alertTitle = currentLang === 'en' ? 'Language update' : 'Mise à jour de la langue';

			if (data.success) {
				wpcore.showAlert('success', alertTitle, data.data.message);
				setTimeout(() => {
					const u = new URL(window.location.href);
					u.searchParams.set('lang', language);
					window.location.href = u.toString();
				}, 1500);
			} else {
				wpcore.showAlert('error', alertTitle, data.data.message);
			}
		} catch (error) {
			console.error(error);
		}
	});
}
